(function () {
  const initAnimation = (section) => {
    if (
      !section ||
      !section.classList.contains("media-banner-section") ||
      !section.querySelector(".animate-on-scroll")
    )
      return;

    const text = section.querySelector(".media-banner__heading");

    if (!text) return;

    ScrollTrigger.create({
      trigger: text,
      start: "50% 95%",
      end: "bottom top",
      onEnter: () => text.classList.add("animated"),
    });
  };

  const initVideoPlayButton = (section) => {
    if (!section || !section.classList.contains("media-banner-section")) return;

    const mediaContainer = section.querySelector(".media-banner__media");
    const videoContainer = section.querySelector(".media-banner__video-wrapper");
    const playButton = section.querySelector(".media-banner__play-button");
    const pauseButton = section.querySelector(".media-banner__pause-button");
    const video = section.querySelector(".media-banner__video-wrapper video");

    if (!video) return;

    const updateVideoState = () => {
      const isPlaying = !video.paused && !video.ended;

      if (mediaContainer) {
        mediaContainer.classList.toggle("is-playing", isPlaying);
      }

      if (playButton) {
        playButton.classList.toggle("media-banner__play-button--hidden", isPlaying);
        playButton.setAttribute("aria-hidden", String(isPlaying));
      }

      if (pauseButton) {
        pauseButton.setAttribute("aria-hidden", String(!isPlaying));
      }
    };

    const playVideo = () => {
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(() => {});
      }
    };

    const pauseVideo = () => {
      video.pause();
    };

    const togglePlayback = () => {
      if (video.paused) {
        playVideo();
        return;
      }

      pauseVideo();
    };

    if (playButton) {
      playButton.addEventListener("click", (event) => {
        event.stopPropagation();
        playVideo();
      });
    }

    if (pauseButton) {
      pauseButton.addEventListener("click", (event) => {
        event.stopPropagation();
        pauseVideo();
      });
    }

    if (videoContainer) {
      videoContainer.addEventListener("click", (event) => {
        if (event.target.closest("button")) return;
        togglePlayback();
      });
    } else {
      video.addEventListener("click", togglePlayback);
    }

    video.addEventListener("play", updateVideoState);
    video.addEventListener("pause", updateVideoState);
    video.addEventListener("ended", updateVideoState);

    updateVideoState();
  };

  const section = document.currentScript.parentElement;
  initAnimation(section);
  initVideoPlayButton(section);

  document.addEventListener("shopify:section:load", function (event) {
    initAnimation(event.target);
    initVideoPlayButton(event.target);
  });
})();
